import styled from 'styled-components';

import { Modal } from 'shared/components/modal/Modals';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

const TranslateActionWrapper = styled.div`
  padding: 20px 20px 0px 20px;
`;

const CustomFieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${device.sm} {
    flex-direction: column;
    padding: 12px 0 0 0;
  }
  @media ${device.md} {
    flex-direction: column;
    padding: 12px 0 0 0;
  }
  @media ${device.lg} {
    padding: 17px 20px 65px 20px;
    flex-direction: row;
  }

  @media ${device.xl} {
    padding: 17px 20px 65px 20px;
    flex-direction: row;
  }

  .input-date {
    float: unset;
  }

  .animate-up {
    animation: moveUp 0.7s linear;
  }

  .animate-down {
    animation: moveDown 0.7s linear;
  }

  @keyframes moveUp {
    0% {
      transform: translateY(85px);
      position: relative;
      z-index: 1000;
    }
    100% {
      transform: translateY(0);
      position: unset;
    }
  }

  @keyframes moveDown {
    0% {
      transform: translateY(-60px);
      position: relative;
      z-index: 1000;
    }
    100% {
      transform: translateY(0);
      position: unset;
    }
  }
`;

const CustomFieldSelectorWrapper = styled.div`
  flex: 0 0 23%;
  min-height: 100%;
  width: 100%;

  .backgroundbox {
    height: 497px;
    width: 100%;
    padding: 0;
    overflow-y: auto;

    .backgroundbox-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid ${colors.lightSilver};
      height: auto;
      width: 100%;

      @media ${device.sm} {
        padding: 1px 4px 1px 3px;
      }
      @media ${device.md} {
        padding: 1px 4px 1px 3px;
      }
      @media ${device.lg} {
        padding: 1px 4px 1px 3px;
      }

      @media ${device.xl} {
        padding: 22px 12px 6px 20px;
      }

      span {
        color: ${colors.suvaGrey};
      }

      svg {
        fill: ${colors.suvaGrey};
        height: 18px;
        width: 18px;
      }
    }

    .backgroundbox-body {
      height: auto;
      width: 100%;
      padding-bottom: 23px;
    }
  }
`;

const CustomFieldText = styled.span`
  font-family: ${fonts.default};
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  @media ${device.sm} {
    font-size: ${fontSizes.xxs}px;
  }
  @media ${device.md} {
    font-size: ${fontSizes.xxs}px;
  }
  @media ${device.lg} {
    font-size: ${fontSizes.sm}px;
  }

  @media ${device.xl} {
    font-size: ${fontSizes.sm}px;
  }
`;

const CustomFieldLabel = styled.label`
  font-family: ${fonts.default};
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 15px;
`;

const SelectorItem = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 45px;
  width: 100%;

  @media ${device.sm} {
    padding: 11px 0 12px 2px;
  }
  @media ${device.md} {
    padding: 11px 0 12px 2px;
  }
  @media ${device.lg} {
    padding: 11px 0 12px 8px;
  }

  @media ${device.xl} {
    padding: 11px 0 13px 18px;
  }

  &:active {
    opacity: 0.5;
  }

  &:hover {
    background-color: ${colors.whiteSmoke};
  }

  svg {
    fill: ${colors.black};
    height: 20px;
    margin-right: 19px;
    width: 20px;
  }

  span {
    color: ${colors.black};
  }
`;

const FieldFormModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding: 0.6rem;
  }
`;

const FieldFormWrapper = styled.div`
  padding: 0 20px;
  padding-bottom: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
    .col-sm-12 {
      padding-left: 0;
    }
  }

  .row-content {
    padding: 0;
    .col-sm-12 {
      padding: 0;
    }
  }
  .form-field {
    margin-top: 26px;
    .required-mark {
      color: ${colors.error};
    }
    .row {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
  .row-border-bottom {
    border-bottom: 1px solid ${colors.spanishGray};
    padding-bottom: 10px !important;
    margin-bottom: 24px;
  }
  .button-icon {
    background-color: ${colors.transparent};
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.md}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;

    &:active {
      opacity: 0.5;
    }

    svg {
      fill: ${colors.black};
      height: 20px;
      width: 20px;
      margin-left: 30px;
    }
  }

  .animate-up {
    animation: moveUp 0.7s linear;
  }

  .animate-down {
    animation: moveDown 0.7s linear;
  }

  @keyframes moveUp {
    0% {
      transform: translateY(85px);
      position: relative;
      z-index: 1000;
    }
    100% {
      transform: translateY(0);
      position: unset;
    }
  }

  @keyframes moveDown {
    0% {
      transform: translateY(-60px);
      position: relative;
      z-index: 1000;
    }
    100% {
      transform: translateY(0);
      position: unset;
    }
  }
`;

const CustomFieldFormWrapper = styled.div`
  flex: 0 0 79%;
  min-height: 100%;

  @media ${device.sm} {
    margin-left: 0;
    width: 109%;
    margin-top: 10px;
    .justify-content-custom-field {
      justify-content: flex-end;
    }
  }
  @media ${device.md} {
    margin-left: 0;
    width: 105%;
    margin-top: 10px;
    .justify-content-custom-field {
      justify-content: space-between !important;
    }
  }
  @media ${device.lg} {
    margin-left: 28px;
    width: 100%;
    margin-top: 0;
    .justify-content-custom-field {
      justify-content: space-between !important;
    }
  }

  @media ${device.xl} {
    margin-left: 28px;
    width: 100%;
    margin-top: 0;
    .justify-content-custom-field {
      justify-content: space-between !important;
    }
  }

  .row-box {
    height: 90%;
    width: 100%;
  }

  .row-actions {
    height: 10%;
    width: 100%;
    margin-top: 22px;
  }

  .backgroundbox {
    display: flex;
    height: 497px;
    padding: 0;
    width: 100%;
    overflow-y: auto;

    .form-fields-container {
      padding: 26px 12px 27px 8px;
      width: 100%;
      .form__form-group {
        width: 98%;
      }
      .row-field {
        margin: 0;
        padding: 0;
        width: 100%;
        .custom-col-field {
          padding: 0;
        }
        .custom-col-field-not-group {
          padding-left: 14px;
        }
      }
    }
  }
`;

const EmptyForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  svg {
    fill: ${colors.suvaGrey};
    height: 62px;
    width: 62px;
    margin-bottom: 7px;
  }

  span {
    color: ${colors.suvaGrey};
    margin-bottom: 5px;
  }

  .subText {
    font-size: ${fontSizes.xs}px;
  }
`;

const GroupFieldWrapper = styled.div`
  background-color: ${colors.whiteSmoke};
  border: 1px solid ${colors.pattens};
  border-radius: 4px;
  height: auto;
  max-height: fit-content;
  min-height: 98px;
  padding: 8px 16px 36px 8px;
  width: 100%;
  overflow: auto;

  .form__form-group-field {
    background-color: ${colors.white};
  }
  .list-field {
    background-color: ${colors.white};
  }
  .form__form-group {
    width: 97% !important;
  }
`;

const CustomModalWrapper = styled(Modal)`
  top: 15%;
  &.translate-modal {
    top: 5%;
    max-width: 930px;
    .row {
      width: 100% !important;
    }
    .translate-icon {
      height: 23px;
      width: 23px;
    }
    select {
      border: none;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
      background-size: 15px;
      height: 24px;
      min-width: 159px;
    }
  }
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding-left: 30px;
    padding-right: 30px;

    .column-name-wrapper {
      background-color: ${colors.whiteSmoke};
      color: ${colors.zambezi};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xs}px;
      font-weight: bold;
      line-height: 15px;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
      height: 35px;
      width: 100%;
    }

    .card-fields {
      background-color: ${colors.white};
      border-radius: 2px;
      box-shadow: 0 0 15px 0 ${colors.mercury};
      height: auto;
      width: 100%;
      padding: 13px 15px 0 15px;
    }
  }
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 8px;
    margin-bottom: 7px;
    width: 100%;

    svg {
      fill: ${colors.black};
      height: 14px;
      width: 18px;
    }

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 15px;
      margin-left: 6px;
    }
  }
`;

export {
  TranslateActionWrapper,
  CustomFieldWrapper,
  CustomFieldSelectorWrapper,
  CustomFieldText,
  CustomFieldLabel,
  SelectorItem,
  FieldFormModal,
  FieldFormWrapper,
  CustomFieldFormWrapper,
  EmptyForm,
  GroupFieldWrapper,
  CustomModalWrapper,
};
